import { render, staticRenderFns } from "./Sun.vue?vue&type=template&id=48cb18e9&scoped=true&lang=pug&"
import script from "./Sun.vue?vue&type=script&lang=js&"
export * from "./Sun.vue?vue&type=script&lang=js&"
import style0 from "./Sun.vue?vue&type=style&index=0&id=48cb18e9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cb18e9",
  null
  
)

export default component.exports